import { useContext } from 'react';
import { MessageContext } from './MessageContext';

// This custom hook does not do anything fancy but makes the code more readable and
// avoids having to write too many lines. It exposes the addMessage and removeMessage
// functions and the options to be used by Modal.

function useModal() {
    const { modalOptions, addMessage, removeMessage } = useContext(
        MessageContext
    );

    return { modalOptions, addMessage, removeMessage };
}

export default useModal;
